module.exports = __webpack_public_path__ + "static/iheart-logo-a10aefe508a1ab39bb67394572fc3393.jpg";